import './App.css';

import EntryPage from './components/LandingPage';



function App() {
  
  return (
    <div className="App">
    <EntryPage />
    
    </div>
    
  );
}

export default App;
